<template>
    <div class="float-left mr-1">
        <span class="text-success" v-if="subItem.status === 1">
            <i
                class="fa fa-toggle-on fa-lg icon-button"
                title="Desativar SubItem"
                @click.stop="confirmaAtivarDesativarSubItem('D')"
            ></i>
        </span>
        <span class="text-secondary" v-if="subItem.status === 0">
            <i
                class="fa fa-toggle-off fa-lg icon-button"
                title="Ativar SubItem"
                @click.stop="confirmaAtivarDesativarSubItem('A')"
            ></i>
        </span>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        subItem: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        confirmaAtivarDesativarSubItem(operacao) {
            let titulo = `${
                operacao === 'A' ? 'Ativação' : 'Desativação'
            } de SubItem`
            let mensagem = `Confirma a ${
                operacao === 'A' ? 'ativação' : 'desativação'
            } do subitem ${this.subItem.ordem} - ${this.subItem.descricao}?`

            if (!this.contratoElaboracao()  && !this.aditivarContrato()) {
                if (this.contratoApostilamento == null) {
                    this.$swal({
                        title: 'O quê deseja fazer ?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Apostilar',
                        cancelButtonText: 'Atualizar'
                    }).then((result) => {
                        if (result.value) {
                            this.alternaJustificativa(
                                result.value == true ? 1 : 0
                            )
                            this.mostrarAlerta(titulo, mensagem)
                        } else if (result.isDismissed) {
                            this.alternaJustificativa(
                                result.isConfirmed == true ? 1 : 0
                            )
                            this.mostrarAlerta(titulo, mensagem)
                        }
                    })
                } else if (this.contratoApostilamento == 1) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta(titulo, mensagem)
                } else if (this.contratoApostilamento == 0) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta(titulo, mensagem)
                }
            } else {
                this.$swal({
                    title: titulo,
                    html: mensagem,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        this.ativarDesativarSubItem()
                    }
                })
            }
        },

        mostrarAlerta(titulo, mensagem) {
            this.$swal({
                title: titulo,
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a ${this.labelJustificativa}`,
                inputValidator: (value) => {
                    if (!value) {
                        return `A justificativa ${this.textoInfoJustificativa} é obrigatória'`
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.ativarDesativarSubItem(result.value)
                }
            })
        },

        ativarDesativarSubItem(justificativa) {
            this.$store.dispatch('addRequest')
            let itemContratoDto = {
                idContrato: this.contrato.idContrato,
                itemContratoId: this.subItem.itemContratoId,
                justificativaApostilamento: justificativa,
                isApostilamento: this.contratoApostilamento
            }
            ContratosServicos.ativarDesativarItemContrato(itemContratoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterSubItensAtualizados')
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'justificativa do apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = 'justificativa'
            }
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-05')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-05')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {},

    watch: {},

    validations: {}
}
</script>
